var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "checkout-summary" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showSummary,
            expression: "showSummary"
          }
        ],
        staticClass: "checkout-summary__container"
      },
      [
        _c("div", { staticClass: "checkout-summary__section" }, [
          _c(
            "button",
            {
              staticClass:
                "checkout-summary__toggle checkout-summary__toggle--open",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleSummary($event)
                }
              }
            },
            [
              _c("span", { staticClass: "screen-reader-text" }, [
                _vm._v(_vm._s(_vm.$modeoL10n.close_summary))
              ])
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "checkout-summary__heading" }, [
            _vm._v(
              "\n        1. " + _vm._s(_vm.$modeoL10n.your_order) + "\n        "
            ),
            _c(
              "a",
              {
                staticClass: "checkout-summary__link",
                attrs: { href: "#tilaus" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.items == 0
                      ? _vm.$modeoL10n.browse_products
                      : _vm.$modeoL10n.edit
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout-summary__text",
              class: { "checkout-summary__text--disabled": _vm.items == 0 }
            },
            [
              _c("p", { staticClass: "checkout-summary__label" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$modeoL10n.products_in_total) +
                    " "
                ),
                _c("span", { staticClass: "checkout-summary__label-detail" }, [
                  _vm._v("(" + _vm._s(_vm.items) + ")")
                ])
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "checkout-summary__value checkout-summary__value--price"
                },
                [
                  _c("price", {
                    attrs: {
                      "price-with-tax": _vm.subTotalWithTax,
                      "price-without-tax": _vm.subTotalWithoutTax
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.discount
            ? _c("div", { staticClass: "checkout-summary__text" }, [
                _c("p", { staticClass: "checkout-summary__label" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$modeoL10n.discount) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "checkout-summary__value checkout-summary__value--price"
                  },
                  [
                    _vm._v(
                      "\n          -" +
                        _vm._s(_vm._f("formatPrice")(_vm.discount)) +
                        "\n        "
                    )
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkout-summary__section" }, [
          _c("p", { staticClass: "checkout-summary__heading" }, [
            _vm._v(
              "\n        2. " +
                _vm._s(_vm.$modeoL10n.contact_details) +
                "\n        "
            ),
            _c(
              "a",
              {
                staticClass: "checkout-summary__link",
                attrs: { href: "#yhteystiedot" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.isBillingAddressEmpty
                      ? _vm.$modeoL10n.fill
                      : _vm.$modeoL10n.edit
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout-summary__text",
              class: {
                "checkout-summary__text--disabled": _vm.isBillingAddressEmpty
              }
            },
            [
              !_vm.isBillingAddressEmpty
                ? _c(
                    "p",
                    [
                      _vm.billingAddress.first_name ||
                      _vm.billingAddress.last_name
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.billingAddress.first_name) +
                                " " +
                                _vm._s(_vm.billingAddress.last_name)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.billingAddress.company
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.billingAddress.company)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.billingAddress.company_id
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.billingAddress.company_id)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.billingAddress.address_1
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.billingAddress.address_1) +
                                ",\n          "
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.billingAddress.postcode || _vm.billingAddress.city
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.billingAddress.postcode) +
                                " " +
                                _vm._s(_vm.billingAddress.city)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.billingAddress.phone
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.billingAddress.phone)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.billingAddress.email
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.billingAddress.email) +
                                "\n          "
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isBillingAddressEmpty
                ? _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$modeoL10n.no_contact_details) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkout-summary__section" }, [
          _c("p", { staticClass: "checkout-summary__heading" }, [
            _vm._v(
              "\n        3. " +
                _vm._s(_vm.$modeoL10n.shipping_method) +
                "\n        "
            ),
            _c(
              "a",
              {
                staticClass: "checkout-summary__link",
                attrs: { href: "#toimitustapa" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.shippingMethod
                      ? _vm.$modeoL10n.edit
                      : _vm.$modeoL10n.select
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout-summary__text",
              class: { "checkout-summary__text--disabled": !_vm.shippingMethod }
            },
            [
              _c("p", { staticClass: "checkout-summary__label" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.shippingMethod
                        ? _vm.shippingMethod.label
                        : _vm.$modeoL10n.no_shipping_method
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm.shippingMethod
                ? _c(
                    "p",
                    {
                      staticClass:
                        "checkout-summary__value checkout-summary__value--price"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("formatPrice")(_vm.shippingMethodPrice)
                          ) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _vm.shippingMethod
          ? _c("div", { staticClass: "checkout-summary__section" }, [
              _c("p", { staticClass: "checkout-summary__heading" }, [
                _vm._v(
                  "\n        4. " +
                    _vm._s(_vm.$modeoL10n.payment_method) +
                    "\n        "
                ),
                _c(
                  "a",
                  {
                    staticClass: "checkout-summary__link",
                    attrs: { href: "#maksutapa" }
                  },
                  [_vm._v(_vm._s(_vm.$modeoL10n.show))]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkout-summary__text checkout-summary__text"
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.paymentMethod.label) + "\n      "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "checkout-summary__section" }, [
          _c("div", { staticClass: "checkout-summary__text" }, [
            _c("p", { staticClass: "checkout-summary__label" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$modeoL10n.subtotal) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "checkout-summary__value checkout-summary__value--price"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("formatPrice")(
                        _vm.subTotalWithoutTaxIncludingShipping
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout-summary__text" }, [
            _c("p", { staticClass: "checkout-summary__label" }, [
              _vm._v("\n          " + _vm._s(_vm.$modeoL10n.vat) + "\n        ")
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "checkout-summary__value checkout-summary__value--price"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("formatPrice")(_vm.totalTax)) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout-summary__total" }, [
            _c("p", { staticClass: "checkout-summary__label" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$modeoL10n.total) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "checkout-summary__total__value checkout-summary__value checkout-summary__value--price"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("formatPrice")(_vm.totalPrice)) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    !_vm.showSummary
      ? _c("div", { staticClass: "checkout-summary__mobile-preview" }, [
          _c(
            "button",
            {
              staticClass: "checkout-summary__toggle",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleSummary($event)
                }
              }
            },
            [
              _c("span", { staticClass: "screen-reader-text" }, [
                _vm._v(_vm._s(_vm.$modeoL10n.show_summary))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "checkout-summary__total checkout-summary__total--mobile"
            },
            [
              _c("p", { staticClass: "checkout-summary__label" }, [
                _vm._v("\n        " + _vm._s(_vm.$modeoL10n.total) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "checkout-summary__total__value checkout-summary__value checkout-summary__value--price"
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatPrice")(_vm.totalPrice)) +
                      "\n      "
                  )
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a44be900", { render: render, staticRenderFns: staticRenderFns })
  }
}